import React from "react";
import backgroundColor from "../themes/backgroundColor";
import portalLayer1 from "../themes/portalLayer1";
import portalLayer2 from "../themes/portalLayer2";
import portalLayer3 from "../themes/portalLayer3";

export default function PortalLayers(props){

    const backgroundPortal = () => { //changes the background color of portal based on weather condition
        if(props.current !== null){
          let background;
          const apiIcon = props.icon;
          for (const item of backgroundColor){
            if (item.icon === apiIcon ){
              background = item.background;
            }
          }
          return background;
        }
    }

    const Layer1 = () => {
        if(props.current !== null){
            let cssStyle;
            const apiIcon = props.icon;
            for (const item of portalLayer1) {
                if (item.icon === apiIcon){
                    cssStyle = item.style;
                }
            }
            return cssStyle;
        }
    }

    const Layer2 = () => {
        if(props.current !== null){
            let cssStyle;
            const apiDesc = props.weatherdesc;
            const apiIcon = () => {
                if (apiDesc === "overcast clouds"){
                    if (props.icon.includes("d")){
                        return "05d";
                    } else {
                        return "05n";
                    }
                } else {
                    return props.icon;
                }
            }
            for (const item of portalLayer2) {
                if (item.icon === apiIcon()){
                    cssStyle = item.style;
                    return cssStyle;
                }
            }
            return cssStyle;
        }
    }

    const Layer3 = () => {
        if(props.current !== null){
            let cssStyle;
            const apiIcon = props.icon;
            for (const item of portalLayer3){
                if (item.icon === apiIcon){
                    cssStyle = item.style;
                    return cssStyle;
                }
            }
            return cssStyle;
        }
    }

    return(
        <div className="portal-inner" style={{background: backgroundPortal()}}>
            <div className="portal-layer1" style={Layer1()}>
            </div>
            <div className="portal-layer2" style={Layer2()}>
            </div>
            <div className="portal-layer3" style={Layer3()}>
            </div>
        </div>
    )
}